import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { PriceElementInterface } from 'common/types/entities/price-element-interface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createPriceElement = (
  parentId: string,
  masterBlockId?: MasterBlockId,
): PriceElementInterface => {
  const entity: PriceElementInterface = {
    ...generateBaseEntity(EntityTypeEnum.PriceElement, parentId, masterBlockId),

    popupIdFirstPlan: null,
    popupIdSecondPlan: null,
    popupIdThirdPlan: null,
    popupIdFourthPlan: null,

    fontFamily: 'Caveat',
    fontStyle: 'normal',
    fontWeight: '700',
  }

  return entity
}
